module.exports = __webpack_public_path__ + "static/media/eos.f61a843b.svg";